import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelopeCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 5V7L12 12L22 7V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 18L17 20L22 15", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M23 10.4639L21 12.4639V5H3V19H11.7559L13.7559 21H1V3H23V10.4639Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconEnvelopeCheck.js.map